import { useQuery } from '@tanstack/react-query';

import { signaturesApi } from '@/lib/api/signatures.api';

export function useSignatures(query?: { status?: string; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['signatures', query],
    queryFn: () => signaturesApi.getSignatureRequests(query),
  });
}

/**
 * Pending signature requests (count + a sample) for the sidebar badge and the
 * daily reminder modal. Shared query key, so both read one request.
 */
export function useSignaturesPendingCount(enabled: boolean) {
  return useQuery({
    queryKey: ['signatures', 'pending-count'],
    queryFn: () => signaturesApi.getPendingCount(),
    enabled,
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
